import { motion } from 'framer-motion';
import React, { useEffect } from 'react';
import { AiFillQuestionCircle } from 'react-icons/ai';
import QdtComponent from '../../components/QdtComponent';
import { useApp } from '../../context/AppContext';
import { fadeIn } from '../../util/animation';


export default function Whatif() {
	const {goToTop, clearAllSelections} = useApp()

	useEffect(() => {
    goToTop()
  }, [goToTop])

  return (
    <motion.div variants={fadeIn} initial="hidden" animate="show">
		<section className="section-space bg-whatif-img bg-overlay">
        <div className="container">
          <div className="row rowsafari">
            <div className="col-lg-12">
              <div className="row">
                <AiFillQuestionCircle color={'white'} size={54}/>
                <h3 className="text-white text-center pt-2">What if?</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
    <section className="mt-3 mb-3">
      <div className="container">
			<div className="row mb-3">
					<div className="col "><h6 className="section-grp-margin-bottom text-success fs-3">What if?</h6></div>
					<div className="col text-light text-end">
						<button onClick={() => clearAllSelections()} className="btn btn-warning text-success">Clear Selections</button>
					</div>
				</div>
        <div className="row rowsafari">
					<div>
						<QdtComponent
							type="QdtViz"
							props={{
								id: 'sJEzX',
								height: '260px'
							}}
						/>
					</div>
          <div className="col-lg-6 col-sm-12 res-desk-mar-bot">
						<div className="border border-success rounded">
							<QdtComponent
									type="QdtViz"
									props={{
										id: 'XDCZR',
										height: '550px'
									}}
								/>
						</div>
          </div>
          <div className="col-lg-6 colsm-12">
						<div className="row rowsafari">
							<div className="col-lg-4 col-md-4 col-sm-12 col-4 res-desk-mar-bot">
								<div className="team-box">
									<QdtComponent
										type="QdtViz"
										props={{
											id: 'BSPngRF',
											height: '80px'
										}}
									/>
								</div>
							</div>
							<div className="col-lg-4 col-md-4 col-sm-12 col-4 res-desk-mar-bot">
								<div className="team-box">
									<QdtComponent
										type="QdtViz"
										props={{
											id: 'PPGGZF',
											height: '80px'
										}}
									/>
								</div>
							</div>
							<div className="col-lg-4 col-md-4 col-sm-12 col-4 res-mob-mar-bot">
								<div className="team-box">
									<QdtComponent
										type="QdtViz"
										props={{
											id: 'PPGGZF',
											height: '80px'
										}}
									/>
								</div>
							</div>
							
						</div>
          </div>
        </div>
      </div>
    </section>
  </motion.div>
  )
}